import React from 'react'
import { useTableContext } from '../Context'
import { RowCountTableStats } from './RowCountTableStats'
import { LoadingTableStats } from './LoadingTableStats'

export const DefaultTableStats = () => {
  const context = useTableContext()
  const stats = context.stats

  //if still loading, show a loading text
  if (context?.listResult?.loading) return <LoadingTableStats />

  if (stats && typeof stats === 'string') {
    return <RowCountTableStats label={stats} />
  }

  return stats || null
}
